<template>
    <DForm @submit.prevent="submitForm">
        <input
            type="hidden"
            :value="form.id"
        >
        <input
            v-model="form.customer_id"
            type="hidden"
        >

        <DFormRow
            :label="__('customers.common.title')"
            :error="errors.title"
        >
            <DSelect
                id="title"
                v-model="form.title"
                :options="titles"
                :placeholder="__('customers.common.select_title')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.firstname')"
            :is-required="true"
            :error="errors.firstname"
        >
            <DInput
                id="firstname"
                v-model="form.firstname"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.lastname')"
            :is-required="true"
            :error="errors.lastname"
        >
            <DInput
                id="lastname"
                v-model="form.lastname"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.email')"
            :is-required="true"
            :error="errors.email"
        >
            <DInput
                id="email"
                v-model="form.email"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.company')"
            :error="errors.company"
        >
            <DInput
                id="company"
                v-model="form.company"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.phone')"
            :errors="errors.phone"
        >
            <DInput
                id="phone"
                v-model="form.phone"
                maxlength="45"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.address1')"
            :error="errors.address1"
        >
            <DInput
                id="address1"
                v-model="form.address1"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.address2')"
            :error="errors.address2"
        >
            <DInput
                id="address2"
                v-model="form.address2"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.postal_code')"
            :error="errors.postal_code"
        >
            <DInput
                id="postal_code"
                v-model="form.postal_code"
                maxlength="12"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.city')"
            :error="errors.city"
        >
            <DInput
                id="city"
                v-model="form.city"
                maxlength="45"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.region')"
            :error="errors.region"
        >
            <DInput
                id="region"
                v-model="form.region"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.common.country')"
            :is-required="true"
            :error="errors.country_code"
        >
            <DSelect
                id="country_code"
                v-model="form.country_code"
                :options="countries"
                :placeholder="__('customers.common.select_country')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.contacts.support_pin')"
            :errors="errors.support_pin"
        >
            <DInput
                id="support_pin"
                v-model="form.support_pin"
                maxlength="6"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.contacts.customer_cloudpit_account_id')"
            :is-required="true"
            :error="errors.customer_cloudpit_account_id"
        >
            <DInput
                id="customer_cloudpit_account_id"
                v-model="form.customer_cloudpit_account_id"
                maxlength="10"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.contacts.support_allowed')"
            :error="errors.support_allowed"
        >
            <DFormCheck
                id="support_allowed"
                v-model="form.support_allowed"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.contacts.email_invoice')"
            :error="errors.email_invoice"
        >
            <DFormCheck
                id="email_invoices"
                v-model="form.email_invoice"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.contacts.email_tech')"
            :error="errors.email_tech"
        >
            <DFormCheck
                id="email_tech"
                v-model="form.email_tech"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.contacts.email_contract')"
            :error="errors.email_contract"
        >
            <DFormCheck
                id="email_contract"
                v-model="form.email_contract"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.contacts.email_newsletter')"
            :error="errors.email_newsletter"
        >
            <DFormCheck
                id="email_newsletter"
                v-model="form.email_newsletter"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.contacts.allow_login')"
            :error="errors.allow_login"
        >
            <DFormCheck
                id="allow_login"
                v-model="form.allow_login"
            />
        </DFormRow>

        <DFormControls
            :cancel-route="$route('customers.customers.contacts.index', {customer: form.customer_id})"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'ContactForm',
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        contact: {
            type: Object,
            default: () => { return {} }
        },
        countries: {
            type: Array,
            default: () => { return [] }
        },
        titles: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['submit'],
    data () {
        return {
            form: this.$inertia.form({
                id: this.contact.id,
                customer_id: this.contact.customer_id,
                firstname: this.contact.firstname,
                lastname: this.contact.lastname,
                title: this.contact.title,
                company: this.contact.company,
                address1: this.contact.address1,
                address2: this.contact.address2,
                postal_code: this.contact.postal_code,
                region: this.contact.region,
                city: this.contact.city,
                country_code: this.contact.country_code ?? this.$page.props.defaultCountry,
                email: this.contact.email,
                phone: this.contact.phone,
                support_pin: this.contact.support_pin,
                customer_cloudpit_account_id: this.contact.customer_cloudpit_account_id,
                support_allowed: this.contact.support_allowed ?? false,
                email_invoice: this.contact.email_invoice ?? false,
                email_tech: this.contact.email_tech ?? false,
                email_contract: this.contact.email_contract ?? false,
                email_newsletter: this.contact.email_newsletter ?? false,
                allow_login: this.contact.allow_login ?? false
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('submit', this.form)
        }
    }
}
</script>
